import Point from "Utility/Point";

interface IGetRopePointsMeta {
    startPoint: Point;
    endPoint: Point;
    resolution: number;
}

export function getPointsAlongRope(meta: IGetRopePointsMeta): Point[] {
    const resolution = Math.round(Math.max(2, meta.resolution));
    const stepX = (meta.endPoint.x - meta.startPoint.x) / resolution;
    const stepY = (meta.endPoint.y - meta.startPoint.y) / resolution;
    const points: Point[] = [];

    for (let i = 0; i <= resolution; i++) {
        points.push(new Point(meta.startPoint.x + stepX * i, meta.startPoint.y + stepY * i));
    }

    return points.sort((a, b) => b.x - a.x);
}
